import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { EstudioService } from '../../estudio.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicBarService } from '../../../../_components/dynamic-bar/dynamic-bar.service';
import { Title } from '@angular/platform-browser';
import { RetroalimentacionService } from '../_services/retroalimentacion.service';
import * as d3 from 'd3';

const chartColors = [
  '#CCC',
  '#CF2A27',
  '#F1C232',
  '#2B78E4',
  '#009E0F'];

@Component({
  selector: 'dashboard-retroalimentacion',
  standalone: false,
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.scss'],
  // tslint:disable-next-line: no-host-metadata-property
  host: {
    '(document:click)': 'offClick($event)',
  }
})

export class DashboardRetroalimentacionComponent implements OnInit, OnDestroy {
  rawData: any;
  ausencias: any[];
  clasesPrevistas = 0;
  comentarios: any[];
  displayedColumns: string[] = ['fecha', 'evidencia', 'comentario'];
  periodos: any[];
  unidades: any[];
  materiaID: any;
  alumnoID: any;
  metas: any[];
  evidencias: any[] = [];
  alumnos: any[];
  isAlumno = false;
  alumno: any;
  textFiltro = '';
  nombresAusencias = ['A0', 'A1', 'A2', 'A3', 'R0', 'R1', 'R2', 'R3'];
  masculinoChecked = true;
  femeninoChecked = true;
  qtyProp = 'cantidad';

  showFilters = true;

  estudioServiceSubscriber: Subscription;

  loading = true;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private dynamicBarService: DynamicBarService,
    private estudioService: EstudioService,
    private retroAlimentacionService: RetroalimentacionService,
    private title: Title,
    private cdRef: ChangeDetectorRef) {
  }


  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.materiaID = params.materiaID;
      this.isAlumno = typeof params.alumnoID !== 'undefined';
      this.alumnoID = typeof params.alumnoID !== 'undefined' ? +params.alumnoID : -1;
      if (this.materiaID) {
        this.processView();
      }
    });

    this.retroAlimentacionService.getObservable().subscribe(data => {
      if (!data) {
        return;
      }
      if (data.event === 'toggle-filters') {
        this.toggleFilter(data.state);
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnDestroy(): void {
    if (this.estudioServiceSubscriber) {
      this.estudioServiceSubscriber.unsubscribe();
    }
  }

  processView() {
    this.estudioServiceSubscriber = this.estudioService.getDashboardRetroalimentacion(this.materiaID, this.alumnoID).subscribe(data => {

      this.rawData = this.estudioService.extractData(data);
      this.rawData.metas.map(meta => {
        if (!meta.hasOwnProperty('showCheck')) {
          meta['showCheck'] = true;
        }
        if (!meta.meta.hasOwnProperty('activeLanguage')) {
          meta.meta['activeLanguage'] = '';
        }
      });
      this.periodos = data['periodos'];
      this.periodos.map(periodo => {
        if (!periodo.hasOwnProperty('checked')) {
          periodo['checked'] = true;
        }
      });
      this.unidades = data['unidades'];
      this.metas = data['metas'];
      this.ausencias = data['ausenciasPeriodo'];
      this.alumnos = data['alumnos'];
      this.clasesPrevistas = data['totalClasesPrevistas'];
      this.comentarios = data['comentarios'];
      this.title.setTitle(`Retroalimentación ${data['materia'].nombreCompleto} - MiGLM`);
      if (this.isAlumno) {
        this.alumno = data['alumnos'].find(al => {
          return +al.id === +this.alumnoID;
        });
        this.title.setTitle(`Retroalimentación ${data['materia'].nombreCompleto} ${this.alumno.nombresApellidos} - MiGLM`);
      }
      this.metas.map(meta => {
        meta.criterios.map(criterio => {
          criterio['glmChartData'] = [];
          criterio.fechas.map(fecha => {
            if (this.isAlumno) {
              const escala = fecha.escalas.find(currEscala => currEscala[this.qtyProp] !== 0);
              if (escala) {
                const glmChartData = { fecha: fecha.fecha, value: escala?.nickName?.toUpperCase(), tooltip: escala?.detalle };
                criterio['glmChartData'].push(glmChartData);
              }
            } else {
              fecha['glmChartData'] = {};
              fecha.escalas.map(currEscala => {
                fecha['glmChartData'][currEscala.nickName] = currEscala[this.qtyProp];
                fecha['glmChartData'][`${currEscala.nickName}Detalle`] = currEscala.detalle;
                fecha['glmChartData']['fecha'] = fecha.fechaLarga;
                fecha['glmChartData']['fechaEvento'] = fecha.fechaEvento;
                fecha['glmChartData']['evidencia'] = fecha.evidencia;
                fecha['glmChartData']['metaID'] = meta.meta.id;
                fecha['glmChartData']['criterioID'] = criterio.criterio.id;
                fecha['glmChartData'][`${currEscala.nickName}CriterioID`] = currEscala.criterioId;
              });
              criterio['glmChartData'].push(fecha['glmChartData']);
            }
            const evidenciaIndex = this.evidencias.findIndex(evidenciaI => evidenciaI.id === fecha.evidencia.id);
            if (evidenciaIndex === -1) {
              const currEvidencia = JSON.parse(JSON.stringify(fecha.evidencia));
              currEvidencia['checked'] = true;
              this.evidencias.push(currEvidencia);
            }
          });
        });
      });
      this.dynamicBarService.setBarra('dashboard-retroalimentacion-barra', { materia: data['materia'] });
      this.loading = false;
    });
  }

  updateChartData() {
    this.metas.map(meta => {
      meta.criterios.map(criterio => {
        criterio['glmChartData'] = null;
        criterio['glmChartData'] = [];
        criterio.fechasDesc.map(fecha => {
          const evidencia = this.evidencias.find(evidenciaI => {
            return evidenciaI.id === fecha.evidencia.id;
          });
          if (evidencia.checked) {
            if (this.isAlumno) {
              const escala = fecha.escalas.find(currEscala => currEscala[this.qtyProp] !== 0),
                glmChartData = { fecha: fecha.fecha, value: escala.nickName.toUpperCase(), tooltip: escala.detalle };
              criterio['glmChartData'].push(glmChartData);
            } else {
              fecha['glmChartData'] = {};
              fecha.escalas.map(currEscala => {
                fecha['glmChartData'][currEscala.nickName] = currEscala[this.qtyProp];
                fecha['glmChartData'][`${currEscala.nickName}Detalle`] = currEscala.detalle;
                fecha['glmChartData']['fecha'] = fecha.fechaLarga;
                fecha['glmChartData']['fechaEvento'] = fecha.fechaEvento;
                fecha['glmChartData']['evidencia'] = fecha.evidencia;
                fecha['glmChartData']['metaID'] = meta.meta.id;
                fecha['glmChartData']['criterioID'] = criterio.criterio.id;
                fecha['glmChartData'][`${currEscala.nickName}CriterioID`] = currEscala.criterioId;
              });
              criterio['glmChartData'].push(fecha['glmChartData']);
            }
          }
        });
        this.cdRef.detectChanges();
      });
    });
  }

  changeAlumno(evt) {
    this.metas = undefined;
    this.unidades = undefined;
    this.ausencias = undefined;
    this.comentarios = undefined;
    this.alumno = undefined;
    if (evt > 0) {
      this.router.navigate(['/', 'estudio', 'retroalimentacion', 'dashboard', 'materia', this.materiaID, 'alumno', evt]);
    } else {
      this.router.navigate(['/', 'estudio', 'retroalimentacion', 'dashboard', 'materia', this.materiaID]);
    }
  }

  filtroPeriodo() {
    const periodosCheck = [];
    this.periodos.map(periodo => {
      if (periodo.checked) {
        periodosCheck.push(periodo.id);
      }
    });
    this.updateAusencias(periodosCheck);
    this.updateUnidades(periodosCheck);
  }

  updateAusencias(periodos) {
    this.ausencias = [];
    const filteredAusencias = this.rawData['ausenciasPeriodo'].filter(peri => {
      return periodos.indexOf(peri.periodoId) > -1;
    });
    this.ausencias = filteredAusencias;
  }

  updateUnidades(periodos) {
    this.unidades.map(unidad => {
      unidad.showMe = false;
      periodos.map(periodo => {
        unidad.showMe = unidad.showMe || unidad.periodoIds.indexOf(periodo) > -1;
      });
    });
    this.filtroUnidad();
  }

  filtroUnidad() {
    const unidadesChecked = [];
    this.unidades.map(uni => {
      if (uni.checked && uni.showMe) {
        unidadesChecked.push(uni.id);
      }
    });
    this.updateMetas(unidadesChecked);
  }

  updateMetas(unidades) {
    const metasIds = [];
    this.rawData.metas.map(currRawMeta => {
      const findedMeta = this.metas.find(currMeta => {
        return currMeta.meta.id === currRawMeta.meta.id;
      });
      if (findedMeta) {
        currRawMeta.checked = findedMeta.checked;
      }
    });
    this.rawData.metas.map(meta => {
      meta.unidadIds.map(unidadID => {
        if (unidades.indexOf(unidadID) > -1) {
          metasIds.push(meta.meta.id);
        }
      });
    });
    const filteredMetas = this.rawData.metas.filter(meta => {
      return metasIds.indexOf(meta.meta.id) > -1;
    });
    this.metas = filteredMetas;
    this.filtroTexto();
  }

  filtroTexto() {
    this.metas.map(meta => {
      meta.showMe = meta.meta[meta.meta['activeLanguage']].toLowerCase().indexOf(this.textFiltro.toLowerCase()) > -1;
    });
  }

  filtroSexo(sexo, checked) {
    if (sexo === 'm') {
      this.masculinoChecked = checked;
    }
    if (sexo === 'f') {
      this.femeninoChecked = checked;
    }

    this.qtyProp = !this.masculinoChecked && this.femeninoChecked ?
      'cantidadFemenino' : this.masculinoChecked && !this.femeninoChecked ?
        'cantidadMasculino' : this.masculinoChecked && this.femeninoChecked || !this.masculinoChecked && !this.femeninoChecked
          ? 'cantidad' : '';
    this.filtroUnidad();
  }

  getDescripcionMeta(meta) {
    let textMeta = '';
    if (meta.txtFR && meta.txtFR.length > 0) {
      textMeta = meta.txtFR;
      meta.activeLanguage = 'txtFR';
    } else if (meta.txtEN && meta.txtEN.length > 0) {
      textMeta = meta.txtEN;
      meta.activeLanguage = 'txtEN';
    } else {
      textMeta = meta.txtES;
      meta.activeLanguage = 'txtES';
    }

    return textMeta;
  }

  getPeriodoLabel(periodoID) {
    const periodo = Object.assign({}, this.periodos.find(per => per.id === periodoID));
    return periodo.nombre;
  }

  getAusencia(tipo) {
    const arrAusencias = this.ausencias.filter(ausencia => {
      return ausencia.tipo === tipo;
    });
    let cantidad = 0;
    arrAusencias.map(aus => {
      cantidad += aus[this.qtyProp];
    });
    return cantidad;
  }

  getFechasAusencias(tipo) {
    const ausencias = this.ausencias.filter(ausencia => {
      return ausencia.tipo === tipo;
    });
    let arrFechas = [];
    ausencias.map(ausencia => {
      arrFechas = arrFechas.concat(ausencia.fechas);
    });
    return arrFechas;
  }

  openFecha(fechaList) {
    if (fechaList.classList.contains('opened')) {
      fechaList.classList.remove('opened');
      fechaList.classList.add('closed');
    } else {
      const elements = document.getElementsByClassName('opened');
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.add('closed');
        elements[i].classList.remove('opened');
      }
      fechaList.classList.add('opened');
      fechaList.classList.remove('closed');
    }
  }

  getDetalleAsistencia(tipoAusencia, contenedor, evt) {
    if (!d3.select(`.tipo${tipoAusencia}`).empty()) {
      d3.select(`.tipo${tipoAusencia}`).remove();
      return;
    }
    d3.select('.cursoDetalle').remove();
    const tipDiv = d3.select(contenedor).append('div')
      .attr('class', `ausenciaDetalle cursoDetalle mat-elevation-z4 tipo${tipoAusencia}`);
    tipDiv.html('<p class="cargando">Cargando</p>');
    this.retroAlimentacionService.getDetalleAsistencia(this.materiaID).subscribe(res => {
      const data = this.estudioService.extractData(res),
        ausenciaData = data.find(ausenciaI => ausenciaI.codigo === tipoAusencia);
      tipDiv.select('.cargando').remove();
      tipDiv.selectAll('.detalle')
        .data(ausenciaData['fechas'])
        .enter().append('p')
        .attr('class', 'detalle')
        .text((d): any => {
          return d;
        });
    }, err => {
      d3.select('.cursoDetalle').remove();
    });
  }

  evidenciaChecked(fecha) {
    const evidencia = this.evidencias.find(evidenciaI => {
      return evidenciaI.id === fecha.evidencia.id;
    });
    return evidencia.checked;
  }

  chartItemClick(evt) {
    const currMeta = this.metas.find(meta => meta.meta.id === evt.data.metaID),
      currCriterio = currMeta.criterios.find(criterio => criterio.criterio.id === evt.data.criterioID),
      currFecha = currCriterio.fechasDesc.find(fecha => fecha.fechaEvento === evt.data.fechaEvento),
      currEscala = currFecha.escalas.find(escala => escala.nickName === evt.key),
      reqData = {
        unidadEventoID: evt.data.evidencia.unidadEventoID,
        fecha: evt.data.fechaEvento.substring(0, 10),
        criterioID: evt.data[`${evt.key}CriterioID`]
      };
    currFecha.evidencia['loadingData'] = true;
    this.retroAlimentacionService.getEventoCriterioData(reqData).subscribe(res => {
      const data = this.estudioService.extractData(res);
      currFecha.evidencia['studentsData'] = { detalle: data.detalle, alumnos: data.alumnos, escala: currEscala };
      currFecha.evidencia['loadingData'] = false;
    }, error => {
      console.error(error);
    });
  }

  toggleFilter(state) {
    this.showFilters = state;
  }

  offClick(evt) {
    const elements = document.getElementsByClassName('opened');
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add('closed');
      elements[i].classList.remove('opened');
    }
  }
}
